import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiStickyDrawerDrawer]',
    standalone: false
})
export class StickyDrawerDrawerDirective {
  @HostBinding('class') class = 'sticky-drawer-drawer';
}
